/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useState, useEffect} from 'react';
import { useTranslation } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import Button from "../../components/Button/Button";
import HomeIcon from "./home_icon.png";
import Drawer from "@material-ui/core/Drawer";
import FeltLogo from "../../components/FeltLogo/FeltLogo";
import Loading from "../../components/Loading/Loading";
import LogoCatbears from "../../components/LogoCatbears/LogoCatbears";
import "./TopNavbar.scss";
import { track } from '../../utils/mixpanel';
import ButtonCircle from "components/ButtonCircle/ButtonCircle";
import { GlobalContext } from 'context/GlobalContext';


function changeLanguage(i18n, langId) {
  if (!langId) {
    const order = ['en', 'he', 'ar', 'ru'];
    const current = i18n.language && order.includes(i18n.language) ? i18n.language : 'en';
    const next = order[(order.indexOf(current) + 1) % order.length];
    langId = next;
  }
  i18n.changeLanguage(langId);
  try {
    localStorage.setItem('i18nextLng', langId);
    localStorage.setItem('i18n:userSet', 'true');
  } catch (_) {}
  return langId;
}

function TopNavbar({
  opacity,
  setVolumeSwitchState,
  VolumeSwitchState,
  hideLogoOnMobile,
  hideLogoOnDesktop,
  border,
  title,
  showNavBG,
  texture,
  removeNavStrip,
  backgroundColor,
  showLogo,
  promptCancelChances,
  showSettingsButton,
  showMenuButton,
  showHomeButton,
  BackLinkTo,
  rightButton,
  brightNav,
  BackOnClick,
  changeStep,
  spacer,
  user,
  authContext,
  showLangButton,
  showFeedbackModalButton,
  openFeedbackPopup,
  setIsFeedbackModalState,
  isOnboarding,
  isFelt,
  disableLogoLink
}) {
  const [navbarState, setNavbarState] = useState({
    isMenuOpen: false,
    opacity,
    title,
    showNavBG,
    texture,
    removeNavStrip,
    showMenuButton,
    showHomeButton,
    BackLinkTo,
    showLogo,
    brightNav,
    showSettingsButton,
    showLangButton,
    showFeedbackModalButton,
    backgroundColor,
  });

  const [isLoadingState, setIsLoadingState] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const history = useHistory(); 
  const {IsPWallOpen, setIsPWallOpen} = useContext(GlobalContext);

  const { t, i18n } = useTranslation();
  const historyHook = useHistory();
  const location = useLocation();
  const hideFeltInMenu = location && typeof location.pathname === 'string' && location.pathname.startsWith('/theatre');

  document.documentElement.style.setProperty('--topNavbar_background-color', backgroundColor);
  document.documentElement.style.setProperty('--topNavbar_opacity', opacity);

  const localeHandler = (i18n) => {
    const langId = changeLanguage(i18n);
    authContext.changeLanguage(langId);
  };

  const handleLanguageClick = () => {
    history.push('/language');
  };
  
  const removeBorder = () => {
    return border === false ? { borderBottom: 'none' } : {};
  };

  const gotoLogin = () => {
    historyHook.push('/login');
  }
  const gotoRegister = () => {
    historyHook.push('/register');
  }

  const handlePromptCancelChanges = () => {
    const message = t(`general.unsavedChanges`);
    if (window.confirm(message)) {
      historyHook.push(BackLinkTo);
    }
  };

  const toggleDrawer = (open) => (event) => {
    setNavbarState({ ...navbarState, isMenuOpen: open });
    try { document.body.classList.toggle('menu-open', open); } catch (_) {}
  };

  // Determine admin by fetching public-config once and comparing user's email
  useEffect(() => {
    let cancelled = false;
    async function loadAdminEmails() {
      const userEmail = (user && user.email ? String(user.email).toLowerCase() : '');
      if (!userEmail) { if (!cancelled) setIsAdmin(false); return; }
      const base =
        (typeof process !== 'undefined' &&
          process.env &&
          process.env.REACT_APP_BACKEND_URL) ||
        '';
      const urls = [
        `${base}/public-config`,
        `/public-config`
      ].filter(Boolean);
      let list = [];
      for (const url of urls) {
        try {
          const resp = await fetch(url, { credentials: 'omit' });
          const j = await resp.json();
          if (j && Array.isArray(j.adminEmails) && j.adminEmails.length) {
            list = j.adminEmails;
            break;
          }
        } catch (_) {}
      }
      if (!cancelled) setIsAdmin(!!(list.includes(userEmail)));
    }
    loadAdminEmails();
    return () => { cancelled = true; };
  }, [user && user.email]);

  const center = (() => {
    if (showLogo) {
      return (
        <div className="top-navbar--center noselect">
          <FeltLogo color="orange" />
        </div>
      );
    } else if (title) {
      return (
        <h1 className={brightNav ? "top-navbar-title__bright noselect" : "top-navbar-title noselect"}>
          {title}
        </h1>
      );
    } else {
      return <div className="top-navbar--spacer noselect"></div>;
    }
  })();

  const leftSide = (() => {
    const isRTL = ['he','ar'].includes(i18n.language);
    const backChevron = isRTL ? '\u203A' : '\u2039';
    return (
      <div className="top-navbar--leftSide noselect">
        {showMenuButton && (
          <div className="top-navbar--menu top-navbar--circle__with-text noselect" onClick={() => { try { track('APP_Felt_Menu_Open'); } catch (_) {} ; toggleDrawer(true)(); }}>
            <span className="textWebNav">{t(`topnavbar.menu.title`)}</span> &#9776;
          </div>
        )}
        {showHomeButton && (
          <Link to={{ pathname: `/` }}>
            <div className="top-navbar--circle noselect">
              <img src={HomeIcon} alt="home icon" width="33" height="30" />
            </div>
          </Link>
        )}
        {showFeedbackModalButton && (
          // <a href="https://forms.gle/x5de7YCEMnrsWSJ66" target="_blank" rel="noopener noreferrer">
            <div onClick={openFeedbackPopup} className="top-navbar--menu top-navbar--circle__with-text top-navbar--feedback noselect">
              <img className="icon-feedback noselect" src={"/assets/icons/icon-feedback.png"} />
              <span className="textWebNav noselect">{t('general.feedback')}</span>
            </div>
          // </a>
        )}
        {BackOnClick && (
          <div className="top-navbar--circle noselect" onClick={BackOnClick}>
              <img className="left-chevron" alt={`button`} src="/assets/icons/chevron-left-icon-dark.png" />
          </div>
        )}
        {BackLinkTo && (
          <div>
            {promptCancelChances ? (
              <div className="top-navbar--circle noselect" onClick={handlePromptCancelChanges}>
                <span className="left-chevron">{backChevron}</span>
              </div>
            ) : (
              <ButtonCircle
              classes={'ButtonCircle-back ButtonCircle-50px '}
              // onClick={()=> {alert("pause!")}}
              to={BackLinkTo}
              />
            )}
          </div>
        )}
      </div>
    );
  })();

  const rightSide = (() => {
    return (
      <div className="top-navbar--rightSide noselect">
        {isFelt ? (
          disableLogoLink ? (
            <div className="top-navbar--feltLogo noselect" aria-label="Felt">
              <img src={"/assets/icons/logo_felt.png"} alt="Felt" />
            </div>
          ) : (
            <a href="/felt" onClick={() => { try { track('APP_Felt_Header_Logo_Click'); } catch (_) {} }} className="top-navbar--feltLogo noselect">
              <img src={"/assets/icons/logo_felt.png"} alt="Felt" />
            </a>
          )
        ) : (
          <LogoCatbears
            isSoundSwitch
            hideLogoOnMobile={hideLogoOnMobile && hideLogoOnMobile}
            hideLogoOnDesktop={hideLogoOnDesktop && hideLogoOnDesktop}
            isFeedbackBtn
            isHovering
          />
        )}
        {rightButton && (
          <div>
            <Button
              classes={`top-navbar__button noselect ${rightButton.color ? "top-navbar__button--color" : ""}`}
              text={rightButton.text}
              onClick={rightButton.onClick}
            />
          </div>
        )}
        {showSettingsButton && (
          <div>
            <div className="top-navbar--circle noselect" onClick={showSettingsButton.onClick}>
              <span className="settings-icon">⋮</span>
            </div>
          </div>
        )}
        {spacer && <div className="top-navbar--spacer noselect"></div>}
      </div>
    );
  })();

  return (
    <>
      {isLoadingState && <Loading />}
      <div className={`top-navbar noselect ${showNavBG ? "top-navbar__bg" : ""} ${removeNavStrip ? "top-navbar-strip--remove" : ""}`} style={removeBorder()}>
        {leftSide}
        {center}
        {rightSide}
        <Drawer
          open={navbarState.isMenuOpen}
          anchor={['he','ar'].includes(i18n.language) ? 'right' : 'left'}
          onClose={toggleDrawer(false)}
          ModalProps={{ style: { zIndex: 6000 }, BackdropProps: { style: { zIndex: 5990 } } }}
          PaperProps={{ style: { zIndex: 6001 } }}
        >
          <div className="menu">
            <div className="menu__nav noselect">
              <h4>{t(`topnavbar.menu.title`)}</h4>
              <p onClick={toggleDrawer(false)}>+</p>
            </div>
            <div className="menu__list">
              <div className="menu__list--top">
                <div className="menu__links noselect">
                  {!isOnboarding && (
                    <>
                      {i18n.language === 'he' && (
                        <a className="menu__links-with-image" href="/theatre">
                          <img src={"/assets/icons/logo-symbol_circle.svg"} />
                          <div>{t(`topnavbar.menu.makeTheatre`)}</div>
                        </a>
                      )}
                      {/* Settings / Account */}
                      <a className="menu__links-with-image" href="/settings">
                        <div style={{display:'flex',alignItems:'center'}}>
                          <span style={{marginInlineEnd: 8}}>⚙️</span>
                          <div>{t('settings.title') || 'Settings'}</div>
                        </div>
                      </a>
                      {/* Felt Button */}
                      {!hideFeltInMenu && (
                        <a className="menu__links-with-image" href="/felt">
                          <img src={"/assets/icons/logo_felt.png"} />
                          <div>{t(`topnavbar.menu.felt`)}</div>
                        </a>
                      )}
                    </>
                  )}
                </div>
                {/* {console.log("user.isGuest ", user.isGuest)} */}
                
                {/* <div className="menu__links noselect">
                  <a href="./hiw">How Felt Works</a>
                </div>
                <div className="menu__links noselect">
                  <a href="./faq">Frequently Asked Questions</a>
                </div> */}
              </div>
              <div className="menu__list--bottom">
                <div className="menu__links noselect">
                  {/* <a href="https://catbears.com/terms/" rel="noopener noreferrer">
                    {t(`topnavbar.menu.terms_and_conditions_button_text`)}
                  </a>
                  <a href="https://catbears.com/privacy/" rel="noopener noreferrer">
                    {t(`topnavbar.menu.privacy_policy_button_text`)}
                  </a> */}

                  {/* ️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥️‍🔥  */}
                 {/* {!user.isSubscribed && (
                    <a onClick={() => {
                      setIsPWallOpen(true)
                      console.log("IsPWallOpen ", IsPWallOpen)
                      }}>
                      <div>הרשמו לדובתולים</div>
                    </a>
                  )}  */}
                  
                  {/* Make Theatre Button */}
                 
                  {user.isGuest && (
                  <>
                        {!isOnboarding && (
                          <>
                            <div>{t("loginFlow.sub-title-to-login")}</div>
                            <a onClick={gotoRegister}>{t("loginFlow.createAnAccount")}</a>
                            <div className="menu-link-margin-top">{t("loginFlow.logInCatbears")}</div>
                          </>
                        )}
                        {isOnboarding && (
                          <div className="menu-link-margin-top">{t("loginFlow.alreadyAccount")}</div>
                        )}
                        <a onClick={gotoLogin}>{t("loginFlow.logIn")}</a>
                  </>
                  )}
                  {!user.isGuest && (
                    <a href="#" onClick={(e) => { e.preventDefault(); authContext.logout(); }}>
                      <div>{t(`topnavbar.menu.logout_button_text`)}</div>
                      <span className="user-email">{user.email}</span>
                      {isAdmin && <div className="admin-badge">Admin</div>}
                    </a>
                  )}

                  {/* Legal links - always visible */}
                  <div className="menu-link-margin-top">
                    <a className="textualLink" href="https://catbears.com/terms/" target="_blank" rel="noopener noreferrer">
                      {t(`topnavbar.menu.terms_and_conditions_button_text`)}
                    </a>
                  </div>
                  <div>
                    <a className="textualLink" href="https://catbears.com/privacy/" target="_blank" rel="noopener noreferrer">
                      {t(`topnavbar.menu.privacy_policy_button_text`)}
                    </a>
                  </div>

                  
                  
                     {/* <a href="/" onClick={() => authContext.logout()}>
                      <div>{t(`topnavbar.menu.logout_button_text`)}</div>
                      <span className="user-email">{user.email}</span>
                    </a> */}
                  
                </div>
                <div className="menu__footer noselect">
                  <p>{t(`topnavbar.menu.copyright`)}</p>
                  {showLangButton && (
                    <div className="menu__footer--lang noselect" onClick={handleLanguageClick}>
                      <span className="settings-icon">{t(`topnavbar.menu.change_language_button_text`)}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
}

export default TopNavbar;
